import React from 'react'

import Image from 'next/image'

import { PaddingProps } from 'styled-system'

import { CheckCircle } from '@phosphor-icons/react'
import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { Button, Column, Row, Text } from 'Components/UI'

import { BackgroundImage } from 'Assets/Images/Sections/BusinessIndividualSection'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { MembershipPackageRecordFieldsFragment } from 'GraphQL/DatoCMS/TypedDocuments'

import { useResponsiveLayout } from 'Hooks'

import {
  CallToHolder,
  Container,
  ListHolder,
  Overflow,
  TitleHolder,
} from './styles'

type Props = PaddingProps & {
  membershipPackage?: MembershipPackageRecordFieldsFragment
  onAction?: () => void
}

function BusinessIndividualSection({
  membershipPackage,
  onAction,
  ...rest
}: Props) {
  const { isDesktop } = useResponsiveLayout()

  const includedFeatures = membershipPackage?.featureEntries.filter(
    featureEntry => featureEntry.isIncluded,
  )

  return (
    <SectionContainer {...rest} px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Container flexDirection={['column', 'column', 'column', 'row']}>
          <Column fullWidth>
            <TitleHolder>
              <Text
                as="h2"
                bold
                inverse
                screen18={!isDesktop}
                screen24={isDesktop}
                uppercase
              >
                Business Individual
              </Text>
            </TitleHolder>

            <ListHolder px={[10, 10, 10, 16]}>
              {includedFeatures?.map(featureEntry => (
                <Row alignCenter gap={4} key={featureEntry.id}>
                  <CheckCircle size={25} weight="fill" />

                  <Text important medium screen18>
                    {featureEntry.feature?.title}
                  </Text>
                </Row>
              ))}

              <Row fullWidth justifyCenter mt={5}>
                <Button large onClick={onAction}>
                  Enquire Now
                </Button>
              </Row>
            </ListHolder>
          </Column>

          <CallToHolder>
            <Image alt="" src={BackgroundImage} />

            <Overflow />

            <Text bold center inverse mb={8} screen28 width="80%">
              Would like to learn more? We&apos;re here to help.
            </Text>

            <Row fullWidth justifyCenter mt={5}>
              <Button large onClick={onAction}>
                Contact Us
              </Button>
            </Row>
          </CallToHolder>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default BusinessIndividualSection
